import translations from '../../translations';
import TranslationExport from './TranslationExport';
import TranslationImport from './TranslationImport';

interface Props {
    container: HTMLElement | null | undefined;
    setIsProcessing: (isProcessing: boolean) => void;
    isActive: boolean;
}

const TranslationBase = ({ container, setIsProcessing, isActive }: Props) => {
    return (
        <>
            <h2>{translations.TRANSLATIONS_main_header}</h2>
            <TranslationExport
                container={container}
                setIsProcessing={setIsProcessing}
                isActive={isActive}
            />
            <TranslationImport container={container} setIsProcessing={setIsProcessing} />
        </>
    );
};

export default TranslationBase;
